/**
 * Overall status of printer connections
 */
export enum PrinterConnectionStatusEnum {
  /**
   * All configured printers are connected and working
   */
  HEALTHY = 'healthy',

  /**
   * Some printers are connected, but not all
   */
  PARTIAL = 'partial',

  /**
   * One or more printers have errors
   */
  ERROR = 'error',

  /**
   * All printers are disconnected
   */
  DISCONNECTED = 'disconnected',

  /**
   * No printers are configured or status unknown
   */
  UNKNOWN = 'unknown',
}
